import React, { Fragment, useState, useEffect } from "react";

import CustomArrowLeft from "../../Common/CustomLeftArrow";
import CustomArrowRight from "../../Common/CustomRightArrow";
import "../../../assets/css/NewArrivals.scss";
import { useNavigate } from "react-router-dom";

import { useSelector, useDispatch } from "react-redux";
import { formatPrice } from "../../../utils";
const NewArrivals = ({ newArrivals }) => {
  const navigate = useNavigate();

  const [startIndex, setStartIndex] = useState(0); // Starting index to show the initial 4 items

  const handleNext = () => {
    if (startIndex + 4 < newArrivals.length) {
      setStartIndex(startIndex + 1);
    }
  };
  const handleMobNext = () => {
    if (startIndex + 1 < newArrivals.length) {
      setStartIndex(startIndex + 1);
    }
  };
  const handlePrev = () => {
    if (startIndex > 0) {
      setStartIndex(startIndex - 1); // Slide one item back
    }
  };

  const handleViewDetails = (e, slug, size) => {
    e.stopPropagation();
    navigate(`/product/${slug}?size=${size}`);
  };
  return (
    <Fragment>
      <div className="head-new-part">
        <h2>New Arrivals</h2>
      </div>
      <div className="new-product-carousel">
        <div className="new-product-slider slider-1">
          <button
            className="prev-btn"
            onClick={handlePrev}
            disabled={startIndex === 0}
          >
            <CustomArrowLeft />
          </button>

          {/* Sliding content with transition */}
          <div className="new-slider-wrapper">
            <div
              className="new-slider-content"
              style={{
                transform: `translateX(-${startIndex * 25}%)`, // Adjust sliding by 25% for each item
              }}
            >
              {newArrivals.map((product) => (
                <div
                  key={product._id}
                  className="new-product-item"
                  onClick={(e) =>
                    handleViewDetails(e, product.slug, product.sizes[0].slug)
                  }
                >
                  <div className="new-product-image">
                    <img
                      src={product.images[0].url}
                      alt={`Product ${product._id}`}
                    />
                  </div>
                  <div className="new-information">
                    <div className="new-head-info">
                      <h3>
                        {" "}
                        {product.name
                          .toLowerCase()
                          .replace(/\b\w/g, (char) => char.toUpperCase())}
                      </h3>

                      {product.priceSale ? (
                        <p>
                          <span className="original-price">
                            {formatPrice(product.price)}
                          </span>{" "}
                          <span className="sale-price">
                            {formatPrice(product.priceSale)}
                          </span>
                        </p>
                      ) : (
                        <p>{formatPrice(product.price)}</p>
                      )}
                    </div>
                    {/* <div className="new-head-price">Rs.{product.price}</div> */}
                  </div>
                  <button
                    className="buy-now-btn"
                    onClick={(e) =>
                      handleViewDetails(e, product.slug, product.sizes[0].slug)
                    }
                  >
                    {/* View Details */}
                    VIEW DETAILS
                  </button>
                </div>
              ))}
            </div>
          </div>

          <button
            className="next-btn"
            onClick={handleNext}
            disabled={startIndex + 4 >= newArrivals.length}
          >
            <CustomArrowRight />
          </button>
        </div>
      </div>
      <div className="new-product-carousel-mob">
        <div className="new-product-slider-mob">
          {/* Sliding content with transition */}
          <div className="new-slider-wrapper-mob">
            <div
              className="new-slider-content-mob"
              // style={{
              //   transform: `translateX(-${startIndex * 100}%)`, // Adjust sliding by 25% for each item
              // }}
            >
              {newArrivals.map((product) => (
                <div
                  key={product._id}
                  className="new-product-item-mob"
                  onClick={(e) =>
                    handleViewDetails(e, product.slug, product.sizes[0].slug)
                  }
                >
                  <div className="new-product-image-mob">
                    <img
                      src={product.images[0].url}
                      alt={`Product ${product._id}`}
                    />
                  </div>
                  <div className="new-information-mob">
                    <div className="new-head-info-mob">
                      <h3>
                        {product.name
                          .toLowerCase()
                          .replace(/\b\w/g, (char) => char.toUpperCase())}
                      </h3>

                      {product.priceSale ? (
                        <p>
                          <span className="original-price">
                            {formatPrice(product.price)}
                          </span>{" "}
                          <span className="sale-price">
                            {formatPrice(product.priceSale)}
                          </span>
                        </p>
                      ) : (
                        <p>{formatPrice(product.price)}</p>
                      )}
                    </div>
                    {/* <div className="new-head-price-mob">Rs.{product.price}</div> */}
                  </div>
                  <button
                    className="buy-now-btn-mob"
                    onClick={(e) =>
                      handleViewDetails(e, product.slug, product.sizes[0].slug)
                    }
                  >
                    {/* View Details */}
                    VIEW DETAILS
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default NewArrivals;
